/**
 * Extracts initials from a full name string.
 *
 * Features:
 * - Handles single names (returns first two characters)
 * - Handles multiple names (returns first and last name initials)
 * - Automatically capitalizes all initials
 * - Filters out empty strings and whitespace
 * - Handles edge cases like empty names and single characters
 * - Preserves proper capitalization rules
 * - Returns undefined for empty or falsy input
 *
 * @param name - The full name string to extract initials from
 * @returns The initials as a string, or undefined if name is empty
 */
export function getInitial(name: string) {
  if (!name) return undefined;

  const nameArray = name.split(" ").filter(Boolean);

  if (nameArray.length > 1)
    return `${nameArray[0][0]?.toUpperCase()}${nameArray[
      nameArray.length - 1
    ][0].toUpperCase()}`;

  if (nameArray[0][1]) {
    return `${nameArray[0][0].toUpperCase()}${nameArray[0][1].toLowerCase()}`;
  }
  return `${nameArray[0][0].toUpperCase()}`;
}
